import { openDB, IDBPDatabase, DBSchema } from "idb";

const DB_NAME = 'rai:settings'

interface IPreview{
  id_preview: string;
}

interface IDb extends DBSchema {
  'rai:users': {
    key: number,
    value: {
      uid_utente: number;
      timestamp?: number;
      autoplay_preview?: boolean;
      audio?: boolean;
      allowed_previews?: IPreview[];
    },
  }
}

type IUser = IDb['rai:users']['value'];

export class RaiSsoSettingsManager {
  protected db!: IDBPDatabase<IDb>;

  constructor() {
    // Check for support.
    if (!("indexedDB" in window)) {
      console.log("This browser doesn't support IndexedDB.");
      return;
    }
    this.setUpDB();
  }

  protected async setUpDB() {
    this.db = await openDB<IDb>(DB_NAME, 3, {
      upgrade(_db, _oldVersion, newVersion, tx) {
        if (newVersion === 3) {
          if (tx.db.objectStoreNames.contains("rai:users")) {
            tx.db.deleteObjectStore("rai:users");
          }
          tx.db.createObjectStore('rai:users', {
            keyPath: "uid_utente"
          });
        }
      },
    });

  }

  /* USERS METHODS */
  public async getUser(_usr: number) {
    const item = await this.db.get('rai:users', _usr);
    return item;
  }

  public async getAllUsers() {
    const items = await this.db.getAll('rai:users');
    return items;
  }

  public async addUser(__userUID: number) {
    const _user: IUser = {
      uid_utente : __userUID,
      timestamp: Math.round(Date.now() / 1000),
      autoplay_preview: true,
      audio: true,
      allowed_previews: []
    };
    await this.db.add('rai:users', _user);
    return _user;
  }

  public async editUser(_user: IUser){
    const tx = this.db.transaction('rai:users', 'readwrite');
    tx.addEventListener('abort', () => {
      const error = tx.error;
      console.error('editUser:', error?.name);
    });
    const user = await tx.store.get(_user.uid_utente);
    const __user = { ...user, ..._user };
    __user.timestamp = Math.round(Date.now() / 1000);
    await tx.store.put(__user);
    await tx.done;
  }

  public async deleteUser(_user: number) {
    await this.db.delete('rai:users', _user)
  }
}

const settingsManager = new RaiSsoSettingsManager();
export { settingsManager };
